export default "__VITE_ASSET__Co1J68aT__"